import { type GridColDef, Text } from '@shared/components';

export interface QConfigGeneratorResult {
  id: string;
  code: string | null;
  name: JSX.Element;
}
export const columns: GridColDef<QConfigGeneratorResult>[] = [
  {
    field: 'code',
    headerName: 'QConfig ID',
    width: 120,
    sortable: false,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      return <Text>{params.row.code}</Text>;
    },
  },
  {
    field: 'name',
    headerName: 'QConfig Name',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return params.row.name;
    },
  },
];
